module.exports = __webpack_public_path__ + "media/images/redesign_apps/hero_background-55ceae727089442d84129eae390371c3.png";